import React from 'react';
import theme from '@/styles/theme';
import { SVGIconType } from '@/components/icons/svg-icon-types';

export interface SignpostIconProps extends SVGIconType {}

const SignpostIcon = ({ width = 16, color, ...props }: SignpostIconProps) => {
  let defaultColor = color ? theme.color[color] : 'black';
  let height = props.height || width;
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.5575 13.5L26.0575 8.5C25.9873 8.42154 25.9014 8.35873 25.8054 8.31566C25.7093 8.27258 25.6053 8.25021 25.5 8.25H16.75V4C16.75 3.80109 16.671 3.61032 16.5303 3.46967C16.3897 3.32902 16.1989 3.25 16 3.25C15.8011 3.25 15.6103 3.32902 15.4697 3.46967C15.329 3.61032 15.25 3.80109 15.25 4V8.25H5C4.53587 8.25 4.09075 8.43437 3.76256 8.76256C3.43437 9.09075 3.25 9.53587 3.25 10V18C3.25 18.4641 3.43437 18.9092 3.76256 19.2374C4.09075 19.5656 4.53587 19.75 5 19.75H15.25V28C15.25 28.1989 15.329 28.3897 15.4697 28.5303C15.6103 28.671 15.8011 28.75 16 28.75C16.1989 28.75 16.3897 28.671 16.5303 28.5303C16.671 28.3897 16.75 28.1989 16.75 28V19.75H25.5C25.6053 19.7498 25.7093 19.7274 25.8054 19.6843C25.9014 19.6413 25.9873 19.5785 26.0575 19.5L30.5575 14.5C30.6805 14.3625 30.7485 14.1845 30.7485 14C30.7485 13.8155 30.6805 13.6375 30.5575 13.5ZM25.1663 18.25H5C4.9337 18.25 4.87011 18.2237 4.82322 18.1768C4.77634 18.1299 4.75 18.0663 4.75 18V10C4.75 9.9337 4.77634 9.87011 4.82322 9.82322C4.87011 9.77634 4.9337 9.75 5 9.75H25.1663L28.9912 14L25.1663 18.25Z"
        fill={defaultColor}
      />
    </svg>
  );
};

export default SignpostIcon;
